import React, { PureComponent } from 'react'
import Header from 'app/Components/Header'
import Partners from 'app/Components/Partners'
import Content from 'app/Components/Content'
import Benefits from 'app/Components/Benefits'
import Divider from 'app/Components/Divider'
import Footer from 'app/Components/Footer'

export default class Index extends PureComponent {

  render() {
    return (
      <div>
        <Header>
          <p>
            We are a network of professionals who aim to strengthen the neuroscience
            industry within the Greater Houston community. We believe that strategic
             partnerships set the foundation for a successful venture.
          </p>
        </Header>
        <Content>
          <h2>How You Benefit</h2>
          <p>
            When you join the GHNI, you don’t just join a new network. You join
            a group of professionals who are top leaders in their fields and are
            ready to share ideas that have never been done before.
          </p>
        </Content>
        <Benefits />
        <Divider />
        <Content>
          <h2>Our Partners</h2>
          <p>
            Meet our partners, the leaders and professionals that make the GHNI not only successful, but possible.
          </p>
        </Content>
        <Partners />
        <Footer />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./index.js
 **/